module.exports = "/_next/static/images/Pat-eea55881d4bba8be00268e7be464f43f.jpg";